import React, { useEffect, useState } from "react";
import "./SideBar.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DashboardIcon from "../../images/icons/NDashboard.png";
import MemberIcon from "../../images/icons/Member.png";
import PayslipIcon from "../../images/icons/Payslip.png"
import ReportIcon from "../../images/icons/Report.png";
import Dashboard_Active from "../../images/icons/NDashboard_Active.png";
import ExpoIcon from "../../images/icons/Expo.png";
import Expo_Active from "../../images/icons/Expo_Active.png";
import ExpoLotIcon from "../../images/icons/ExpoLot.png";
import ExpoLot_Active from "../../images/icons/ExpoLot_Active.png";
import LotIcon from "../../images/icons/Lot.png";
import Lot_Active from "../../images/icons/Lot_Active.png";
import Member_Active from "../../images/icons/Member_Active.png";
import ProductIcon from "../../images/icons/Product.png";
import Product_Active from "../../images/icons/Product_Active.png";
import Payslip_Active from "../../images/icons/Payslip_Active.png"
import defaultLogo from "../../images/smk_logo.png";
import logout from "../../images/icons/logout.png";
import dropdown_arrow from "../../images/icons/NDropdown.png";
import dropup_arrow from "../../images/icons/NDropup.png";
import api from "../../api/api";
import apiUtil from "../../api/apiUtil";
import getToken from "../../pages/getToken";
import LeftArrowIcon from "../../images/icons/left_arrow.png";
import RightArrowIcon from "../../images/icons/right_arrow.png";
import Logo from "../../images/smk_logo.jpg";
import authStore from "../../store/authStore";

const SideBar = (props) => {
  const isShowSideBar = props.isShowSideBar;
  const [activeTab, setActiveTab] = useState(null);
  const [reportDropdown, setReportDropdown] = useState(false);
  const [logoImage, setLogoImage] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const navigate = useNavigate();
  const auth = authStore((state) => state.auth);
  const clearAuthData = authStore((state) => state.clearAuthData);

  const brandId = auth?.brandId;

  useEffect(() => {
  }, []);

  const hideDropdown = () => {
    setReportDropdown(false);
  };
  useEffect(() => {
    getAdminInfo();
  }, []);

  const getAdminInfo = () => {
    if (!auth) return;

    const param = {
      userId: auth.userId,
      brandId: auth.brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            location.href = "/login";
          } else if (response.data.code === 200) {
            setModuleList(response.data.data.adminModules);
            // handleRedirection(response.data.data.adminModules);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  // const handleRedirection = (moduleList) => {
  //   for (const action of moduleActions) {
  //     const module = moduleList.find(
  //       (module) => module.name === action.name && module.accessLevel === 4
  //     );
  //     if (module) {
  //       if (action.route) navigate(action.route);
  //       if (action.tab) setActiveTab(action.tab);
  //       hideDropdown();
  //       return;
  //     }
  //   }
  // };
  // const moduleActions = [
  //   { name: "Dashboard", route: "/dashboard", tab: "Dashboard" },
  // ];
  const location = useLocation();

  useEffect(() => {
    const pathToTabMapping = {
      dashboard: "Dashboard",
      expo: "Expo",
      expoLot: "ExpoLot",
      member: "Member",
      lot: "Lot",
      product: "Product",
      payslip: "Payslip",
      "report/member-report": "MemberReport",
      "report/product-report": "ProductReport",
      "report/expolot-report": "ExpoLotReport",
      "report/lot-report": "LotReport",
    };

    const path = location.pathname.replace(/^\//, "");
    const tab = pathToTabMapping[path];

    if (tab) {
      setActiveTab(tab);
      hideDropdown();

      if (
        tab === "MemberReport" || tab === "ProductReport" || tab === "ExpoLotReport" || tab === "LotReport"
      ) {
        setReportDropdown(true);
      }
    }
  }, [location.pathname]);

  const getActiveTab = (tabName, activeTab) => {
    return activeTab === tabName ? "activeItem" : "menuItem";
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setActiveTab(true);
    }
  };
  const toggleSidebar = (openIcon, closeIcon) => {
    return props.isShowSideBar ? openIcon : closeIcon;
  };
  const onToggleNav = () => {
    if (props.setShowSideBar) {
      props.setShowSideBar(!isShowSideBar);
    }
  };

  const iconSources = {
    Dashboard: () =>
      activeTab === "Dashboard" ? Dashboard_Active : DashboardIcon,
    Member: () => (activeTab === "Member" ? Member_Active : MemberIcon),
    Product: () => (activeTab === "Product" ? Product_Active : ProductIcon),
    Payslip: () => (activeTab === "Payslip" ? Payslip_Active : PayslipIcon),
    Expo: () => (activeTab === "Expo" ? Expo_Active : ExpoIcon),
    ExpoLot: () => (activeTab === "ExpoLot" ? ExpoLot_Active : ExpoLotIcon),
    Lot: () => (activeTab === "Lot" ? Lot_Active : LotIcon),
  };

  return (
    <div className={toggleSidebar("NavBar", "NavBar NavBarIcon")}>

      <div
        className="Open"
        onClick={onToggleNav}
      >
      </div>
      <img
        src={logoImage.valueInText ? logoImage.valueInText : defaultLogo}
        className={`Logo ${logoImage.valueInText}`}
        alt="SMK_logo"
      />
      <div className="position-relative scrollbar">
        <ul className="sidebar-menu">
          {moduleList.some(
            (module) => module.name == "Dashboard" && module.accessLevel == 4
          ) && (
              <Link to="/dashboard">
                <li
                  className={getActiveTab("Dashboard", activeTab)}
                  onClick={() => setActiveTab("Dashboard")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Dashboard"]()}
                      className="nav_Icon"
                      alt="dashboard_icon"
                    />
                    {isShowSideBar && <span>ပင်မ စာမျက်နှာ</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Expo" && module.accessLevel == 4
          ) && (
              <Link to="/expo">
                <li
                  className={getActiveTab("Expo", activeTab)}
                  onClick={() => setActiveTab("Expo")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Expo"]()}
                      className="nav_Icon"
                      alt="expo_icon"
                    />
                    {isShowSideBar && <span>ပြပွဲ</span>}
                  </div>
                </li>
              </Link>
            )}

          {/* {moduleList.some(
            (module) => module.name === "Expo" && module.accessLevel == 4
          ) && (
              <Link to="/expolot">
                <li
                  className={getActiveTab("ExpoLot", activeTab)}
                  onClick={() => setActiveTab("ExpoLot")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["ExpoLot"]()}
                      className="nav_Icon"
                      alt="payslip_icon"
                    />
                    {isShowSideBar && <span>ပြပွဲ အရောင်းကုန်</span>}
                  </div>
                </li>
              </Link>
            )} */}

          {moduleList.some(
            (module) => module.name == "Member" && module.accessLevel == 4
          ) && (
              <Link to="/member">
                <li
                  className={getActiveTab("Member", activeTab)}
                  onClick={() => setActiveTab("Member")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Member"]()}
                      className="nav_Icon"
                      alt="member_icon"
                    />
                    {isShowSideBar && <span>ကုန်သည်</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Lot" && module.accessLevel == 4
          ) && (
              <Link to="/lot">
                <li
                  className={getActiveTab("Lot", activeTab)}
                  onClick={() => setActiveTab("Lot")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Lot"]()}
                      className="nav_Icon"
                      alt="lot_icon"
                    />
                    {isShowSideBar && <span>ရောင်းပြီး ကုန်စည်</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Product" && module.accessLevel == 4
          ) && (
              <Link to="/product">
                <li
                  className={getActiveTab("Product", activeTab)}
                  onClick={() => setActiveTab("Product")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Product"]()}
                      className="nav_Icon"
                      alt="product_icon"
                    />
                    {isShowSideBar && <span>ကယ်ရီ</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name === "Payslip" && module.accessLevel == 4
          ) && (
              <Link to="/payslip">
                <li
                  className={getActiveTab("Payslip", activeTab)}
                  onClick={() => setActiveTab("Payslip")}
                  onKeyDown={handleKeyDown}
                >
                  <div className={toggleSidebar("navLink", "navIcon")}>
                    <img
                      src={iconSources["Payslip"]()}
                      className="nav_Icon"
                      alt="payslip_icon"
                    />
                    {isShowSideBar && <span>ပြေစာ</span>}
                  </div>
                </li>
              </Link>
            )}

          {moduleList.some(
            (module) => module.name == "Report" && module.accessLevel == 4
          ) && (
              <>
                <li
                  className="menuItem"
                  onClick={() => {
                    if (
                      location.pathname.includes("report/member-report")
                      || location.pathname.includes("report/product-report")
                      || location.pathname.includes("report/expolot-report")
                      || location.pathname.includes("report/lot-report")
                    ) {
                      setReportDropdown(!reportDropdown);
                      setActiveTab("MemberReport");
                    } else {
                      setReportDropdown(true);
                      navigate("/report/member-report");
                      setActiveTab("MemberReport");
                    }
                  }}
                  onKeyDown={handleKeyDown}
                >
                  <div
                    className={`helpCenterNavLink ${toggleSidebar(
                      "navLink",
                      "navIcon"
                    )}`}
                  >
                    <img src={ReportIcon} className="nav_Icon" alt="ReportIcon" />
                    {isShowSideBar ? (
                      <>
                        <span>မှတ်တမ်းများ</span>
                        {reportDropdown ? (
                          <img
                            src={dropup_arrow}
                            className="imgDropdownupArrow"
                            alt="dropup_arrow"
                          />
                        ) : (
                          <img
                            src={dropdown_arrow}
                            className="imgDropdownupArrow"
                            alt="dropdown_arrow"
                          />
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </li>
                {reportDropdown && (
                  <>
                    <Link to="/report/member-report">
                      <li
                        className={getActiveTab("MemberReport", activeTab)}
                        onClick={() => setActiveTab("MemberReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>ကုန်သည် စာရင်း</span>}
                        </div>
                      </li>
                    </Link>
                    <Link to="/report/product-report">
                      <li
                        className={getActiveTab("ProductReport", activeTab)}
                        onClick={() => setActiveTab("ProductReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>ကယ်ရီ စာရင်း</span>}
                        </div>
                      </li>
                    </Link>
                    {/* <Link to="/report/expolot-report">
                      <li
                        className={getActiveTab("ExpoLotReport", activeTab)}
                        onClick={() => setActiveTab("ExpoLotReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>ပြပွဲ အရောင်းစာရင်း</span>}
                        </div>
                      </li>
                    </Link> */}
                    <Link to="/report/lot-report">
                      <li
                        className={getActiveTab("LotReport", activeTab)}
                        onClick={() => setActiveTab("LotReport")}
                        onKeyDown={handleKeyDown}
                      >
                        <div className={toggleSidebar("navLink", "navIcon")}>
                          {toggleSidebar && <span>ရောင်းပြီး ကုန်စည်စာရင်း</span>}
                        </div>
                      </li>
                    </Link>
                  </>
                )}
              </>
            )}
        </ul>
      </div>
      <ul className={`position-relative ${toggleSidebar("", "hideNavIcon")}`}>
        <Link to="/login">
          <li
            onClick={() => {
              clearAuthData();
            }}
            className="logOut-container menuItem"
            onKeyDown={handleKeyDown}
          >
            <div className="Logout_button navLink text-center">
              <img src={logout} className="nav_Icon" alt="logout_icon" />
              {isShowSideBar ? <span className="logout">Log out</span> : <></>}
            </div>
          </li>
        </Link>
      </ul>
    </div >
  );
};

export default SideBar;
